export const fallbackLocale = 'en-US';
export default function I18nOptions(locale) {
    return {
        fallbackLng: fallbackLocale,
        keySeparator: false,
        lng: locale,
        load: 'currentOnly',
        nsSeparator: false,
        resources: {},
        supportedLngs: [locale, fallbackLocale],
    };
}
//# sourceMappingURL=I18nOptions.js.map